import { ApiSchema } from "@api-types";

export namespace FiltersHelper {
  export const getResponsesFilters = (
    filterIds: {
      [x: string]: number[];
    },
    questionOptionIds: {
      [x: number]: {
        [x: number]: boolean;
      };
    },
    panelType: ApiSchema.PanelType | undefined,
    regionId: number,
    // Making these optional for now for the Groups.bloc (but should probably be added)
    selectedSurveyRunIds?: number[] | null, // | undefined,
    selectedDates?: [Date | null, Date | null], // | undefined,
  ) => {
    const flatFilters = Object.values(filterIds ?? {}).flat();
    const includeIds = filterSubDictionaryByValue(questionOptionIds, true)
      .map((a) => a.ids)
      .flat();
    const excludeIds = filterSubDictionaryByValue(questionOptionIds, false)
      .map((a) => a.ids)
      .flat();
    return {
      filterIds: flatFilters,
      excludeQuestionOptionsIds: excludeIds,
      regionIds: [regionId],
      questionOptionsIds: includeIds,
      testOptionIds: undefined,
      surveyIds: selectedSurveyRunIds ?? undefined,
      panelType,
      dateFrom: selectedDates?.[0] ? selectedDates[0].toISOString() : undefined,
      dateTo: selectedDates?.[1] ? selectedDates[1].toISOString() : undefined,
    } as ApiSchema.SegmentResponsesFilters;
  };

  export const compareFilters = (
    filter1: ApiSchema.SegmentResponsesFilters,
    filter2: ApiSchema.SegmentResponsesFilters,
  ) => {
    if (
      // check basic types
      (filter1.dateTo ?? null) !== (filter2.dateTo ?? null) ||
      (filter1.dateFrom ?? null) !== (filter2.dateFrom ?? null) ||
      (filter1.panelType ?? null) !== (filter2.panelType ?? null) ||
      // check length
      (filter1.regionIds ?? []).length !== (filter2.regionIds ?? []).length ||
      (filter1.filterIds ?? []).length !== (filter2.filterIds ?? []).length ||
      (filter1.questionOptionsIds ?? []).length !== (filter2.questionOptionsIds ?? []).length ||
      (filter1.standardQuestionIds ?? []).length !== (filter2.standardQuestionIds ?? []).length ||
      (filter1.excludeQuestionOptionsIds ?? []).length !== (filter2.excludeQuestionOptionsIds ?? []).length ||
      (filter1.surveyIds ?? []).length !== (filter2.surveyIds ?? []).length ||
      // check values
      (filter1.regionIds?.length &&
        !!filter1.regionIds?.filter((f1) => !filter2.regionIds?.find((f2) => f2 === f1)).length) ||
      (filter1.filterIds?.length &&
        !!filter1.filterIds?.filter((f1) => !filter2.filterIds?.find((f2) => f2 === f1)).length) ||
      (filter1.questionOptionsIds?.length &&
        !!filter1.questionOptionsIds?.filter((f1) => !filter2.questionOptionsIds?.find((f2) => f2 === f1))
          .length) ||
      (filter1.standardQuestionIds?.length &&
        !!filter1.standardQuestionIds?.filter((f1) => !filter2.standardQuestionIds?.find((f2) => f2 === f1))
          .length) ||
      (filter1.excludeQuestionOptionsIds?.length &&
        !!filter1.excludeQuestionOptionsIds?.filter(
          (f1) => !filter2.excludeQuestionOptionsIds?.find((f2) => f2 === f1),
        ).length) ||
      (filter1.surveyIds?.length &&
        !!filter1.surveyIds?.filter((f1) => !filter2.surveyIds?.find((f2) => f2 === f1)).length)
    ) {
      return false;
    }
    return true;
  };
  export const filterDictionaryByValue = (dictionary: { [key in number]: boolean }, value: boolean) =>
    Object.keys(dictionary)
      .map((a) => Number(a))
      .filter((a) => dictionary[a] === value);

  export const filterSubDictionaryByValue = (
    dictionary: { [key in number]: { [key in number]: boolean } },
    value: boolean,
  ) =>
    Object.keys(dictionary)
      .map((a) => Number(a))
      ?.map((questionId) => ({
        questionId,
        ids: Object.keys(dictionary[questionId] ?? {})
          .map((a) => Number(a))
          .filter((a) => dictionary[questionId]![a] === value),
      }));
  export const getDictionaryGroupedByValue = (dictionary: {
    [key in number]: { [key in number]: boolean };
  }) =>
    Object.keys(dictionary)
      .map((a) => Number(a))
      ?.map((questionId) => ({
        questionId,
        trueIds: Object.keys(dictionary[questionId] ?? {})
          .map((a) => Number(a))
          .filter((a) => dictionary[questionId]![a] === true),
        falseIds: Object.keys(dictionary[questionId] ?? {})
          .map((a) => Number(a))
          .filter((a) => dictionary[questionId]![a] === false),
      }));
}
